import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function PupverseAccountRemove() {
  return (
    <PolicyLayout
      title="account removal"
      appName="Pupverse: Dog Training"
      date="SEPTEMBER 2025"
    >
      <p>
        This page explains how users of Pupverse: Dog Training can request account and
        personal data deletion.
      </p>

      <div className={s.title}>1) How to request account deletion</div>
      <p>
        To request deletion, email account@goodwavelab.com with the subject:
        "Pupverse: Dog Training - Account deletion request".
      </p>
      <p>Please include:</p>
      <ul>
        <li>Your full name or nickname used in the app.</li>
        <li>The email linked to your account (if applicable).</li>
        <li>Your platform (Android or iOS).</li>
        <li>Confirmation that you want your account and related data deleted.</li>
      </ul>

      <div className={s.title}>2) What data can be deleted</div>
      <p>
        After identity verification (when needed), the Service Provider deletes
        or anonymizes account-linked information controlled by Pupverse: Dog
        Training,
        including profile-related data, support messages, and technical account
        identifiers associated with your user profile.
      </p>

      <div className={s.title}>3) Data retention exceptions</div>
      <p>
        Some records may be retained for a limited time for legal, security, or
        abuse-prevention purposes. These may include operational logs and
        minimal compliance records as required by law.
      </p>

      <div className={s.title}>4) Processing time</div>
      <p>
        Deletion requests are processed within a reasonable period after all
        required information is received. In most cases, this is completed
        within 30 days.
      </p>

      <div className={s.title}>5) Contact</div>
      <p>
        For account deletion and privacy-related requests, contact:
        account@goodwavelab.com.
      </p>
    </PolicyLayout>
  );
}
